import moment from "moment";

export function isEmpty(value) {
  return (
    value == null ||
    value == undefined ||
    (typeof value === "string" && value.trim().length === 0)
  );
}
export function isEmptyObj(obj) {
  for (const prop in obj) {
    if (Object.hasOwn(obj, prop)) {
      return false;
    }
  }

  return true;
}
export function isValidDate(date) {
  if (Object.prototype.toString.call(date) === "[object Date]") {
    if (isNaN(date.getTime())) {
      return false;
    } else {
      return true;
    }
  }
}
export function getWordsInitials(str) {
  var matches = str.match(/\b(\w)/g);
  var acronym = matches.join("");
  return acronym;
}

export function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}

export const openInNewTab = (url) => {
  const newWindow = window.open(url, "_blank", "noopener,noreferrer");
  if (newWindow) newWindow.opener = null;
};



export const paramsToObject = (params) => {
  const obj = {};
  const para = new URLSearchParams(params);

  for (const [key, value] of para) {

    if (obj.hasOwnProperty(key)) {
      if (Array.isArray(obj[key])) {
        obj[key].push(value);
      } else {
        obj[key] = [obj[key], value];
      }
    } else {
      obj[key] = value;
    }
  }

  return obj;
}

export const getUrlParamFromLocation = (paramString) => {
  var urlPayload = paramsToObject(paramString);
  urlPayload = {
    ...urlPayload,
    noOfPassenger: parseInt(urlPayload.noOfPassenger),
    infant: parseInt(urlPayload.infant),
    child: parseInt(urlPayload.child),
  }
  return urlPayload;
}

export const hasSearchOnLocation = () => location.search.length > 0;

export const plainSearchToMyRequestObj = (_) => {
  let postdata = {
    noOfPassenger: _.noOfPassenger,
    cabinClass: _.cabinClass,
    flightNumber: null,
    tripType: _.tripType,
    nationality: _.nationality,
    flexiDate: 0,
    returnDate: _.return ? _.return : "",
    fareType: _.fareType,
    passengerType: [
      {
        quantity: parseInt(_.noOfPassenger),
        code: "ADT",
        typeName: null,
      },
    ],
    originDestination: [
      {
        origin: _.from,
        destination: _.to,
        departDateTime: moment(_.departure).format("YYYY/MM/DD hh:mm"),
      },
    ],
  };
  if (_.child > 0) {
    postdata.passengerType.push({
      quantity: parseInt(_.child),
      code: "CHD",
      typeName: null,
    });
  }
  if (_.infant > 0) {
    postdata.passengerType.push({
      quantity: parseInt(_.infant),
      code: "INF",
      typeName: null,
    });
  }
  return postdata;
}

export const isNumeric = (str) => {
  if (typeof str != "string") return false // we only process strings!  
  return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
    !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
}

export function slugify(text) {
  if (!text) return "";
  return text
    .toString()
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')     // Replace spaces with -
    .replace(/[^\w-]+/g, '')    // Remove all non-word chars
    .replace(/--+/g, '-');    // Replace multiple - with single -
}